<template>
    <div>
        <router-link :to="returnPath" class="back-to-outfit gray-bottom-border">
            <div class="wtw-container">
                <span class="stay-black">{{ returnTitle }}</span>
            </div>
        </router-link>
        <div v-if="outfitCurrent" class="purchase-outfit-items-container">
            <purchase-outfit-item 
                v-for="(product, index) in outfitCurrent.products"
                :key="product.product_id"
                :product="product"
                :optionChanged="(option, event) => changeProduct(index, setOption(option, outfitCurrent.products[index], event))"
                :toggleProduct="() => toggleOutfitProduct(index)"
                :swapProduct="setSwapProduct"
                ref="product" />
        </div>
        <div class="wtw-container text-center">
            <div class="button pink full add-items-to-cart"
                 @click.stop="addProductsToCart"
                 :class="{disabled: !anyProductsSelected}"
            >
                Add Selected Items to Cart
            </div>
        </div>
        <transition name="fade">
            <div v-show="dataLoading || !outfitCurrent" class="loading-overlay">
                <loader></loader>
            </div>
        </transition>
        <transition name="fade">
            <swap-item :product="swapProduct" v-if="showSwapProduct" :showSizes="true"></swap-item>
        </transition>
    </div>
</template>

<script>
    import Mixins from "../../mixins/mixins.js";
    import ProductMixins from "../../mixins/product-mixins.js";
    import {mapGetters} from "vuex";
    import {_} from 'vue-underscore';
    import Loader from '../common/loader.vue';
    import PurchaseOutfitItem from './purchase-outfit-item.vue';
    import SwapItem from "../products/swap-item.vue";

    export default {
        mixins: [Mixins, ProductMixins],
        props: ['outfitCurrent', 'returnTitle', 'returnPath'],
        data() {
            return {
                dataLoading: false,
                swapProduct: null,
                showSwapProduct: false,
            }
        },
        components: {
            Loader,
            PurchaseOutfitItem,
            SwapItem
        },
        computed: {
            anyProductsSelected(){
                if(this.outfitCurrent && this.outfitCurrent.products) {
                    let selectedProducts = this.outfitCurrent.products.filter((product) => {
                        return product.selected
                    });

                    return selectedProducts.length;
                } else {
                    return 0;
                }
            },
            ...mapGetters({
                user: "auth/getUser"
            })
        },
        created(){
            if(!this.outfitCurrent || !this.outfitCurrent.products){
                this.$router.push({path: this.returnPath})
            }

            this.$on('closeSwapModal', () => {
                this.showSwapProduct = false;
            });
        },
        methods: {
            addProductsToCart() {
                if (this.validateProductSizes(this.outfitCurrent.products)) {
                    this.dataLoading = true;
                    this.$store.dispatch({
                        type: "cart/insertProductsToCart",
                        // Filter any product with no size selected
                        products: this.outfitCurrent.products.filter(product => !!product.product_option_value_id_size),
                        user: this.user
                    }).then(() => {
                        this.$router.push({path: "/cart"});
                    }).catch(error => {
                        this.$helpers.trackEvent("add_to_cart_error", {content_id: this.outfitCurrent.outfit_id});
                        this.$store.dispatch('errors/put', error.message || 'Invalid product or option combination.');
                        this.dataLoading = false;
                    });
                }
            },
            validateProductSizes(products){
                let allSizesSelected = true;
                _.each(products, (product) => {
                    if (product.selected) {
                        if (!product.product_option_value_id_size) {
                            if (product.product_sizes && product.product_sizes.length > 0) {
                                this.updateValidation('size', product);
                                allSizesSelected = false;
                            }
                        }
                        if (!product.product_option_value_id_color) {
                            if (product.product_colors && product.product_colors.length > 0) {
                                this.updateValidation('color', product);
                                allSizesSelected = false;
                            }
                        }
                    }
                });

                if(!allSizesSelected) {
                    const product = products.filter(product => product.warnAbout && (product.warnAbout.color || product.warnAbout.size))[0];
                    const productRef = product && this.$refs.product.find(productRef => productRef.product.product_id == product.product_id);
                    if(productRef) productRef.$el.scrollIntoView(false);
                }

                return allSizesSelected;
            },
            toggleOutfitProduct(index) {
                this.$store.commit('outfits/toggleOutfitProduct', { index });
            },
            setSwapProduct(product) {
                this.showSwapProduct = true;
                this.swapProduct = product;
     
                this.$helpers.trackEvent("swap_init", {content_id: product.product_id});
            },
            changeProduct(index, product) {
                this.$store.dispatch({
                    type: "outfits/changeOutfitProduct",
                    index,
                    product,
                    outfitId: this.outfitCurrent.outfit_id,
                });
            }
        }
    };
</script>
